import React, { useEffect, useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { ScanLine } from 'lucide-react';
import ScannerDetailsModal from './ScannerDetailsModal';
import { openCompactModal } from '../../../../../utils/modal/modal.helper';
import wsClient from '../../../../../utils/web-socket-client';

const ScannerConfiguration = () => {
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
        setIsConnected(wsClient.isConnected());

        const handleConnect = () => setIsConnected(true);
        const handleDisconnect = () => setIsConnected(false);

        wsClient.onConnect(handleConnect);
        wsClient.onDisconnect(handleDisconnect);

        return () => {
            wsClient.removeConnectListener(handleConnect);
            wsClient.removeDisconnectListener(handleDisconnect);
        };
    }, []);

    const handleOpenScannerModal = () => {
        openCompactModal(ScannerDetailsModal, {
            onSave: (ip, port) => {
                localStorage.setItem('scanner_ip', ip);
                localStorage.setItem('scanner_port', port);
                wsClient.connect(ip, port);
            },
            isConnected
        });
    };

    // Same round button as the invitations and notifications buttons next to it, with the
    // connection status as a dot where they show their count.
    return (
        <Tooltip
            title={
                isConnected
                    ? 'Scanner connected · Configure'
                    : 'Scanner not connected · Configure'
            }
        >
            <IconButton
                aria-label="Scanner configuration"
                onClick={handleOpenScannerModal}
                sx={{
                    bgcolor: '#f8f8f8',
                    border: '0.762px solid #dedede',
                    borderRadius: '999px',
                    width: '32px',
                    height: '32px',
                    minWidth: '32px',
                    p: 0,
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    '&:hover': {
                        bgcolor: '#efefef'
                    }
                }}
            >
                <ScanLine size={17} color="#212322" />
                <Box
                    data-testid="scanner-status"
                    sx={{
                        position: 'absolute',
                        top: '-3px',
                        left: '-1px',
                        width: '11px',
                        height: '11px',
                        borderRadius: '50%',
                        border: '2px solid white',
                        bgcolor: isConnected ? '#33C78F' : '#F04134'
                    }}
                />
            </IconButton>
        </Tooltip>
    );
};

export default ScannerConfiguration;
